<div class="container">
  <div class="row">
    <div class="col-auto pl-1 m-0" *ngIf="!isValid">
      <div style="width: 5px; height: 90%;" class="eca-invalid-bg"></div>
    </div>
    <div class="col m-0 p-0">
      <div class="form-group">
        <label *ngIf="label" [for]="controlId"><strong>{{label}}</strong> <span *ngIf="showUpdateMessage && updateMessage" class="eca-invalid"> - {{updateMessage}}</span></label>
        <div *ngIf="!isValid && validationMessage" class="eca-invalid"><strong>{{validationMessage}}</strong></div>
        <div class="input-group eca-flex-nowrap">
          <p-dropdown [id]="controlId"
                      [(options)]="options"
                      optionLabel="name"
                      optionValue="id"
                      [(ngModel)]="selectedId"
                      (onChange)="selectedIdChanged()"
                      [disabled]="isReadOnly"
                      [autoDisplayFirst]="false"
                      [placeholder]="placeholderText"
                      [showClear]="allowClear"
                      appendTo="body"></p-dropdown>

          <ng-template #popTemplate>
            <div *ngIf="!!popoverText" [ngClass]="isRequired ? 'required-input-guide' : 'optional-input-guide'"
                 [innerHtml]="popoverText"></div>
          </ng-template>
          <div class="input-group-append" *ngIf="popoverText">
            <app-eca-input-guide [popoverText]="popoverText"
                                 [isRequired]="isRequired"
                                 [isDisabled]="isReadOnly">
            </app-eca-input-guide>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
